import React, { useState } from 'react'

const LINK_BUTTONS = {
    onboardingUrl: { label: 'Onboarding Link', text: 'Complete Onboarding' },
    paymentUrl: { label: 'Payment Link', text: 'Pay Invoice' },
    zoomUrl: { label: 'Join Zoom Meeting', text: 'Join Meeting' },
}

export default function MergeTagSidebar({ mergeTags = [], onInsertTag, onInsertButton }) {
    const [isOpen, setIsOpen] = useState(true)

    const linkTagNames = new Set(Object.keys(LINK_BUTTONS))
    const regularTags = mergeTags.filter(({ tag }) => !linkTagNames.has(tag.replace(/^\{\{|\}\}$/g, '')))
    const buttonTags = mergeTags
        .map(({ tag }) => tag.replace(/^\{\{|\}\}$/g, ''))
        .filter((name) => linkTagNames.has(name))
        .map((name) => ({ name, ...LINK_BUTTONS[name] }))

    const handleDragStartTag = (e, tagName) => {
        e.dataTransfer.setData('application/x-merge-tag', tagName)
        e.dataTransfer.effectAllowed = 'copy'
    }

    const handleDragStartButton = (e, text, url) => {
        e.dataTransfer.setData('application/x-button-block', JSON.stringify({ text, url }))
        e.dataTransfer.effectAllowed = 'copy'
    }

    return (
        <aside
            className="bg-white border-r border-gray-200 flex flex-col shrink-0 overflow-hidden transition-all duration-200"
            style={{ width: isOpen ? 200 : 36 }}
        >
            <div className="flex items-center gap-2 px-2.5 py-2.5 border-b border-gray-100 min-h-[40px]">
                {isOpen && (
                    <div className="flex-1 min-w-0">
                        <p className="text-[10px] font-semibold text-gray-500 uppercase tracking-wide leading-none">Merge Tags</p>
                        <p className="text-[10px] text-gray-400 mt-0.5 leading-none">Click or drag to insert</p>
                    </div>
                )}
                <button
                    type="button"
                    onClick={() => setIsOpen((v) => !v)}
                    className="p-1 rounded hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer shrink-0 ml-auto"
                    title={isOpen ? 'Collapse sidebar' : 'Expand sidebar'}
                >
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        style={{ transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.2s' }}
                    >
                        <polyline points="15 18 9 12 15 6" />
                    </svg>
                </button>
            </div>

            {isOpen && (
                <div className="flex-1 overflow-y-auto p-2 flex flex-col gap-0.5">
                    {regularTags.map(({ tag, label }) => {
                        const tagName = tag.replace(/^\{\{|\}\}$/g, '')
                        return (
                            <button
                                type="button"
                                key={tag}
                                draggable
                                onDragStart={(e) => handleDragStartTag(e, tagName)}
                                onMouseDown={(e) => { e.preventDefault(); onInsertTag(tagName) }}
                                className="text-left w-full px-2.5 py-2 rounded-md transition-colors group cursor-grab hover:bg-teal-50 active:cursor-grabbing"
                            >
                                <div className="text-xs font-medium text-gray-700 leading-tight truncate group-hover:text-[#115E59]">
                                    {label}
                                </div>
                                <div className="text-[10px] text-gray-400 font-mono mt-0.5 leading-tight truncate group-hover:text-[#0d9488]">
                                    {tag}
                                </div>
                            </button>
                        )
                    })}

                    {buttonTags.length > 0 && (
                        <>
                            <div className="mt-3 mb-1 px-2.5 border-t border-gray-100 pt-3">
                                <p className="text-[10px] font-semibold text-gray-500 uppercase tracking-wide leading-none">Buttons</p>
                                <p className="text-[10px] text-gray-400 mt-0.5 leading-none">Click or drag to insert</p>
                            </div>
                            {buttonTags.map(({ name, label, text }) => (
                                <button
                                    type="button"
                                    key={name}
                                    draggable
                                    onDragStart={(e) => handleDragStartButton(e, text, `{{${name}}}`)}
                                    onMouseDown={(e) => { e.preventDefault(); onInsertButton(text, `{{${name}}}`) }}
                                    className="w-full px-2.5 py-2 rounded-md transition-colors cursor-grab hover:bg-teal-50 active:cursor-grabbing"
                                >
                                    <div className="w-full rounded bg-[#115E59] text-white text-[10px] font-semibold text-center py-1.5 px-2 pointer-events-none">
                                        {label}
                                    </div>
                                </button>
                            ))}
                        </>
                    )}
                </div>
            )}
        </aside>
    )
}
